import { Tba } from '../tba';

export class DefineRangeTypePayload {
  name: string;
  statisticalMethod: number;
  tba: Tba;
}
